import { LinkStyle } from '../../domain';
import type { LinkLineStyle, LinkMarkStyle } from '@model-framework/link';
import { LinkColor, LinkLineStyleMenuView, LinkMarkStyleMenuView, ReverseLinkButton } from '@model-framework/link';
import { LinkMenuId } from './LinkMenuId';
import { LinkMultiplicityMenuContent } from './LinkMultiplicityMenuContent';
import { TrashMenuButton } from '@model-framework/menu';
import { MenuSize } from '@view-model/models/sticky/ui';
import { ColorMenu } from '@model-framework/color/ColorMenu';
import { useTranslation } from 'react-i18next';
type Props = {
  menuId: LinkMenuId;
  style: LinkStyle;
  isMultiplicityEnabled: boolean;
  isOpen: boolean;
  onMenuOpen(): void;
  onMenuClose(): void;
  onLineStyleSelected(lineStyle: LinkLineStyle): void;
  onMarkStyleSelected(markStyle: LinkMarkStyle): void;
  onColorSelected(color: LinkColor): void;
  onToggleMultiplicityEnabled(): void;
  onReverseLink(): void;
  onDeleteLink(): void;
};

export const LinkMenuContent: React.FC<Props> = ({
  menuId,
  style,
  isOpen,
  isMultiplicityEnabled,
  onMenuOpen,
  onMenuClose,
  onLineStyleSelected,
  onMarkStyleSelected,
  onColorSelected,
  onToggleMultiplicityEnabled,
  onReverseLink,
  onDeleteLink,
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      {menuId === LinkMenuId.LineStyle && (
        <LinkLineStyleMenuView
          menuSize={MenuSize}
          currentLineStyle={style.lineStyle}
          items={LinkStyle.lineStyles}
          isOpen={isOpen}
          onMenuClicked={isOpen ? onMenuClose : onMenuOpen}
          onSelected={onLineStyleSelected}
          text={t('canvas.menu.lineStyle')}
        />
      )}
      {menuId === LinkMenuId.MarkStyle && (
        <LinkMarkStyleMenuView
          menuSize={MenuSize}
          currentMarkStyle={style.markStyle}
          items={LinkStyle.markStyles}
          isOpen={isOpen}
          onMenuClicked={isOpen ? onMenuClose : onMenuOpen}
          onSelected={onMarkStyleSelected}
          text={t('canvas.menu.linkType')}
        />
      )}
      {menuId === LinkMenuId.Multiplicity && (
        <LinkMultiplicityMenuContent
          isEnabled={isMultiplicityEnabled}
          menuSize={MenuSize}
          onClick={onToggleMultiplicityEnabled}
          text={t('canvas.menu.link.multiplicity')}
        />
      )}
      {menuId === LinkMenuId.ReverseLink && (
        <ReverseLinkButton menuSize={MenuSize} onClick={onReverseLink} text={t('canvas.menu.reverseLink')} />
      )}
      {menuId === LinkMenuId.Color && (
        <ColorMenu
          currentColorName={style.color}
          menuSize={MenuSize}
          items={LinkColor.menuItems()}
          isOpen={isOpen}
          text={t('canvas.menu.color')}
          onMenuClicked={isOpen ? onMenuClose : onMenuOpen}
          onSelected={onColorSelected}
        />
      )}
      {menuId === LinkMenuId.DeleteLink && (
        <TrashMenuButton menuSize={MenuSize} onClick={onDeleteLink} text={t('common.action.delete')} />
      )}
    </>
  );
};
